import React from "react";
import { useNavigate } from "react-router-dom";
import { useBreakpoints } from "react-breakpoints-hook";

import { EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import SwiperContent from "./SwiperContent";

export default function Banner({ largeText, largeTextExtra, extraText }) {
  let { xs, sm, md, lg, xlg } = useBreakpoints({
    xs: {
      min: 0,
      max: 360,
    },
    sm: {
      min: 361,
      max: 960,
    },
    md: {
      min: 961,
      max: 1400,
    },
    lg: {
      min: 1401,
      max: null,
    },
  });

  const [swiperInstance, setSwiperInstance] = React.useState();

  return (
    <Swiper
      className="flex flex-column"
      style={{
        height:  "100vh",
      }}
      modules={[Autoplay, EffectFade]}
      effect="fade"
      grabCursor={true}
      spaceBetween={30}
      slidesPerView={1}
      autoplay={{
        delay: 5500,
        disableOnInteraction: false,
      }}
      onSwiper={(swiper) => {
        setSwiperInstance(swiper);
      }}
    >
      {["bg1", "bg2"].map((i, _) => (
        <SwiperSlide
          key={_}
          className={`${i} py-3 px-3 md:px-5 lg:px-8  relative`}
          // className={`bg-gray-800 py-3 px-3 md:px-5 lg:px-8  relative`}
        >
          <SwiperContent swiper={swiperInstance} index={_} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
